/* The Woolshire cart (rebrand 2026, replaces the earlier custom drawer script).
   One controller, two views of the same cart: the drawer (sections/cart-drawer.liquid, on every
   page) and the /cart page (sections/woolshire-cart.liquid). Both render the same markup from the
   same snippets, so after every change this script asks Shopify to re-render both sections
   (Section Rendering API) and morphs each view in place: lines by key (quantity, price), the
   suggestion card only when its state changed, the Rest Assured line, the shipping line, totals.
   Contract kept for layout/theme.liquid and the header: window.cartDrawer.{open, close, refresh,
   addFromForm, isOpen}, [data-cart-drawer][data-open], [data-cart-close], [data-cart-count].
   The suggestion's Add buttons ([data-ws-cta-add], variant id on the button; the fill radios
   [data-ws-cta-fill] move the id and the price) add through /cart/add.js without leaving the cart. */
(function () {
  'use strict';

  var DRAWER_SECTION = 'cart-drawer';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function q(sel, root) { return (root || document).querySelector(sel); }
  function qa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------------------------------------------------------------- a view: one rendering of the cart */
  function View(root, sectionId) {
    this.root = root;
    this.sectionId = sectionId;
  }

  View.prototype.stage = function () { return q('[data-cart-stage]', this.root); };

  View.prototype.setBusy = function (busy) { this.root.setAttribute('data-busy', busy ? 'true' : 'false'); };

  View.prototype.message = function (text) {
    var el = q('[data-cart-msg]', this.root);
    if (!el) return;
    if (text) { el.textContent = text; el.hidden = false; } else { el.textContent = ''; el.hidden = true; }
  };

  View.prototype.announce = function (text) {
    var el = q('[data-cart-live]', this.root);
    if (!el) return;
    el.textContent = '';
    setTimeout(function () { el.textContent = text; }, 40);
  };

  // Morph this view from the freshly rendered section HTML.
  View.prototype.apply = function (html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = q('[data-cart-view]', doc);
    if (!fresh) return;
    var cur = this.stage(), nxt = q('[data-cart-stage]', fresh);
    if (!cur || !nxt) return;

    var curEmpty = !!q('[data-cart-empty]', cur), nxtEmpty = !!q('[data-cart-empty]', nxt);
    if (curEmpty !== nxtEmpty) {
      // in or out of the empty state: whole stage
      cur.innerHTML = nxt.innerHTML;
    } else if (!nxtEmpty) {
      morphItems(q('[data-cart-items]', cur), q('[data-cart-items]', nxt));
      // the suggestion: replace only when its state changed, so a chosen fill survives other edits
      var curCta = q('[data-cart-cta]', cur), nxtCta = q('[data-cart-cta]', nxt);
      if (curCta && nxtCta) {
        if (curCta.getAttribute('data-cta-state') !== nxtCta.getAttribute('data-cta-state')) curCta.replaceWith(nxtCta.cloneNode(true));
      } else if (nxtCta && !curCta) {
        var items = q('[data-cart-items]', cur);
        if (items) items.insertAdjacentElement('afterend', nxtCta.cloneNode(true));
      } else if (curCta && !nxtCta) {
        curCta.remove();
      }
      copyHidden('[data-cart-assure]', cur, nxt);
      copyHidden('[data-cart-ship]', cur, nxt);
      copyHtml('[data-cart-discounts]', cur, nxt, true);
      copyText('[data-cart-total]', cur, nxt);
    }
    var count = fresh.getAttribute('data-cart-item-count');
    if (count != null) this.root.setAttribute('data-cart-item-count', count);
  };

  function copyHidden(sel, cur, nxt) {
    var a = q(sel, cur), b = q(sel, nxt);
    if (a && b) a.hidden = b.hasAttribute('hidden');
  }
  function copyText(sel, cur, nxt) {
    var a = q(sel, cur), b = q(sel, nxt);
    if (a && b && a.textContent !== b.textContent) a.textContent = b.textContent;
  }
  function copyHtml(sel, cur, nxt, withHidden) {
    var a = q(sel, cur), b = q(sel, nxt);
    if (!a || !b) return;
    if (a.innerHTML !== b.innerHTML) a.innerHTML = b.innerHTML;
    if (withHidden) a.hidden = b.hasAttribute('hidden');
  }

  // Lines by key: update quantity and price in place (the photo never reloads), insert new lines in
  // order, drop the gone ones.
  function morphItems(curList, nxtList) {
    if (!curList || !nxtList) return;
    var byKey = {};
    qa('[data-cart-item]', curList).forEach(function (el) { byKey[el.getAttribute('data-key')] = el; });
    var seen = {}, prev = null;
    qa('[data-cart-item]', nxtList).forEach(function (nxt) {
      var key = nxt.getAttribute('data-key');
      seen[key] = true;
      var cur = byKey[key];
      if (cur) {
        var qty = nxt.getAttribute('data-quantity');
        cur.setAttribute('data-quantity', qty);
        var input = q('[data-qty-value]', cur);
        if (input && String(input.value) !== qty) input.value = qty;
        var dec = q('[data-qty-decrement]', cur);
        if (dec) { if (parseInt(qty, 10) <= 1) dec.setAttribute('aria-disabled', 'true'); else dec.removeAttribute('aria-disabled'); }
        var p = q('[data-line-price]', cur), np = q('[data-line-price]', nxt);
        if (p && np && p.innerHTML !== np.innerHTML) p.innerHTML = np.innerHTML;
        var d = q('[data-line-discounts]', cur), nd = q('[data-line-discounts]', nxt);
        if (nd && !d && p) p.insertAdjacentElement('afterend', nd.cloneNode(true));
        else if (d && !nd) d.remove();
        else if (d && nd && d.innerHTML !== nd.innerHTML) d.innerHTML = nd.innerHTML;
        if (prev && prev.nextElementSibling !== cur) prev.insertAdjacentElement('afterend', cur);
        prev = cur;
      } else {
        var clone = nxt.cloneNode(true);
        if (prev) prev.insertAdjacentElement('afterend', clone); else curList.insertAdjacentElement('afterbegin', clone);
        prev = clone;
      }
    });
    Object.keys(byKey).forEach(function (key) { if (!seen[key]) byKey[key].remove(); });
  }

  /* ---------------------------------------------------------------- the controller */
  function Cart(drawerRoot) {
    this.views = [];
    this.drawer = null;
    this.busy = false;
    this.previouslyFocused = null;
    this.selfCount = false;
    if (drawerRoot) {
      this.drawer = new View(drawerRoot, DRAWER_SECTION);
      this.views.push(this.drawer);
    }
    var pageRoot = q('[data-ws-cart-page]');
    if (pageRoot) this.views.push(new View(pageRoot, pageRoot.getAttribute('data-section-id')));
    this.bind();
  }

  // open a collapsed section (<details>) that a #link points at, and scroll to it
  function revealHash(hash, push) {
    var id = decodeURIComponent((hash || '').replace(/^#/, ''));
    if (!id) return;
    var el = document.getElementById(id);
    if (!el) return;
    var details = el.tagName === 'DETAILS' ? el : el.closest('details');
    if (details && !details.open) details.open = true;
    if (push && location.hash !== '#' + id) { try { history.pushState(null, '', '#' + id); } catch (_) {} }
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  }
  // same-page #links anywhere (the buy box's "How it works" too), and arriving with a #hash
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href*="#"]');
    if (!a || e.defaultPrevented) return;
    var url; try { url = new URL(a.getAttribute('href'), location.href); } catch (_) { return; }
    if (url.origin !== location.origin || url.pathname !== location.pathname || !url.hash) return;
    var el = document.getElementById(decodeURIComponent(url.hash.slice(1)));
    if (!el || !(el.tagName === 'DETAILS' || el.closest('details'))) return;
    e.preventDefault(); revealHash(url.hash, true);
  });
  window.addEventListener('hashchange', function () { revealHash(location.hash, false); });
  if (location.hash) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(function () { revealHash(location.hash, false); }, 120); });
    else setTimeout(function () { revealHash(location.hash, false); }, 120);
  }

  Cart.prototype.sectionIds = function () { return this.views.map(function (v) { return v.sectionId; }).filter(Boolean).join(','); };


  Cart.prototype.bind = function () {
    var self = this;

    // close: capture phase so we beat any third-party click handler
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-cart-close]');
      if (!t || !self.drawer || !self.drawer.root.contains(t)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      self.close();
    }, true);

    // links inside the drawer (e.g. Rest Assured "How it works"): close the drawer first. A link to a
    // spot on the page you're already on (#promise on the pillow page) then scrolls there and opens it;
    // a link to another page just navigates.
    document.addEventListener('click', function (e) {
      if (!self.drawer || !self.isOpen()) return;
      var a = e.target.closest('a[href]');
      if (!a || !self.drawer.root.contains(a) || a.closest('[data-cart-close]')) return;
      var url; try { url = new URL(a.getAttribute('href'), location.href); } catch (_) { return; }
      self.close();
      if (url.origin === location.origin && url.pathname === location.pathname && url.hash) {
        e.preventDefault();
        setTimeout(function () { revealHash(url.hash, true); }, 60);
      }
    }, true);

    // quantity, remove, suggestion: delegated inside every view
    this.views.forEach(function (view) {
      view.root.addEventListener('click', function (e) { self.onClick(e, view); });
      view.root.addEventListener('change', function (e) { self.onChange(e, view); });
      view.root.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-qty-value]')) { e.preventDefault(); e.target.blur(); }
      });
    });

    document.addEventListener('keydown', function (e) {
      if (!self.isOpen()) return;
      if (e.key === 'Escape') { self.close(); return; }
      if (e.key === 'Tab') self.trapFocus(e);
    });
  };

  Cart.prototype.onClick = function (e, view) {
    var ctaBtn = e.target.closest('[data-ws-cta-add]');
    if (ctaBtn && view.root.contains(ctaBtn)) {
      e.preventDefault();
      var card = ctaBtn.closest('[data-ws-cta]');
      var checked = card ? q('[data-ws-cta-fill]:checked', card) : null;
      var id = (checked && checked.value) || ctaBtn.getAttribute('data-variant-id');
      var name = ctaBtn.getAttribute('data-product-title') || '';
      if (checked && checked.getAttribute('data-name')) name += ', ' + checked.getAttribute('data-name');
      this.addVariant(id, 1, view, name);
      return;
    }
    var item = e.target.closest('[data-cart-item]');
    if (!item || !view.root.contains(item)) return;
    var key = item.getAttribute('data-key');
    var qty = parseInt(item.getAttribute('data-quantity'), 10) || 0;
    if (e.target.closest('[data-cart-remove]')) { e.preventDefault(); this.changeQty(key, 0, view); return; }
    if (e.target.closest('[data-qty-increment]')) { e.preventDefault(); this.changeQty(key, qty + 1, view); return; }
    if (e.target.closest('[data-qty-decrement]')) { e.preventDefault(); if (qty > 1) this.changeQty(key, qty - 1, view); return; }
  };

  Cart.prototype.onChange = function (e, view) {
    var t = e.target;
    if (t.matches('[data-ws-cta-fill]')) {
      var card = t.closest('[data-ws-cta]');
      if (!card) return;
      var price = q('[data-ws-cta-price]', card);
      if (price && t.getAttribute('data-price')) price.textContent = t.getAttribute('data-price');
      var btn = q('[data-ws-cta-add]', card);
      if (btn) {
        btn.setAttribute('data-variant-id', t.value);
        var tpl = btn.getAttribute('data-label-template');
        if (tpl) btn.setAttribute('aria-label', tpl.replace('[fill]', t.getAttribute('data-name') || ''));
      }
      return;
    }
    if (t.matches('[data-qty-value]')) {
      var item = t.closest('[data-cart-item]');
      if (!item) return;
      var n = parseInt(t.value, 10);
      if (isNaN(n) || n < 0) { t.value = item.getAttribute('data-quantity'); return; }
      if (String(n) === item.getAttribute('data-quantity')) return;
      this.changeQty(item.getAttribute('data-key'), n, view);
      return;
    }
    if (t.matches('[data-cart-note]')) {
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note: t.value }), credentials: 'same-origin' }).catch(function () {});
    }
  };

  /* ---- drawer open / close */
  Cart.prototype.isOpen = function () { return !!this.drawer && this.drawer.root.getAttribute('data-open') === 'true'; };

  Cart.prototype.open = function () {
    if (!this.drawer || this.isOpen()) return;
    this.previouslyFocused = document.activeElement;
    this.drawer.root.setAttribute('data-open', 'true');
    this.drawer.root.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var panel = q('.ws-cart__panel', this.drawer.root);
    requestAnimationFrame(function () { if (panel) panel.focus({ preventScroll: true }); });
  };

  Cart.prototype.close = function () {
    if (!this.drawer || !this.isOpen()) return;
    this.drawer.root.setAttribute('data-open', 'false');
    this.drawer.root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    this.drawer.message('');
    var prev = this.previouslyFocused;
    if (prev && prev.focus && document.contains(prev)) { try { prev.focus({ preventScroll: true }); } catch (_) {} }
  };

  Cart.prototype.trapFocus = function (e) {
    var panel = q('.ws-cart__panel', this.drawer.root);
    var focusable = qa('a[href], button:not([disabled]), input:not([disabled]):not([type="radio"]), input[type="radio"]:checked:not([disabled]), textarea, select, [tabindex]:not([tabindex="-1"])', panel)
      .filter(function (el) { return el.offsetParent !== null || el === panel; });
    if (!focusable.length) { e.preventDefault(); panel.focus(); return; }
    var first = focusable[0], last = focusable[focusable.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };

  /* ---- requests */
  Cart.prototype.setBusy = function (busy) {
    this.busy = busy;
    this.views.forEach(function (v) { v.setBusy(busy); });
  };

  Cart.prototype.request = function (url, body, isForm) {
    var opts = { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };
    if (isForm) { body.append('sections', this.sectionIds()); body.append('sections_url', window.location.pathname); opts.body = body; }
    else { body.sections = this.sectionIds(); body.sections_url = window.location.pathname; opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
    return fetch(url, opts).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (data) {
        if (!r.ok) { var err = new Error(data.description || data.message || 'Something went wrong.'); err.data = data; throw err; }
        return data;
      });
    });
  };

  // The theme's product forms land here (layout/theme.liquid intercepts every /cart/add submit).
  Cart.prototype.addFromForm = function (form) {
    if (this.busy) return Promise.resolve();
    this.setBusy(true);
    var submit = form.querySelector('button[type="submit"], input[type="submit"], [data-add-to-cart]');
    if (submit) submit.disabled = true;
    var self = this;
    return this.request('/cart/add.js', new FormData(form), true)
      .then(function (data) {
        self.applySections(data.sections);
        self.views.forEach(function (v) { v.message(''); });
        if (self.drawer) { self.drawer.announce(lineName(data) + ' added to your cart.'); self.scrollTop(); }
        self.open();
      })
      .catch(function (err) {
        console.error('[cart] add failed:', err);
        if (self.drawer) { self.open(); self.drawer.message(err.message || 'Something went wrong. Please try again.'); }
      })
      .then(function () { self.setBusy(false); if (submit) submit.disabled = false; });
  };

  // The suggestion's Add buttons: adds without leaving the cart; the open view re-renders.
  Cart.prototype.addVariant = function (id, quantity, view, name) {
    if (this.busy || !id) return Promise.resolve();
    this.setBusy(true);
    var self = this;
    return this.request('/cart/add.js', { items: [{ id: parseInt(id, 10), quantity: quantity || 1 }] })
      .then(function (data) {
        self.applySections(data.sections);
        self.views.forEach(function (v) { v.message(''); });
        view.announce((name || lineName(data)) + ' added to your cart.');
        if (view === self.drawer) self.scrollTop();
      })
      .catch(function (err) {
        console.error('[cart] add failed:', err);
        view.message(err.message || 'Something went wrong. Please try again.');
      })
      .then(function () { self.setBusy(false); });
  };

  Cart.prototype.changeQty = function (key, quantity, view) {
    if (this.busy) return Promise.resolve();
    this.setBusy(true);
    var self = this;
    return this.request('/cart/change.js', { id: key, quantity: quantity })
      .then(function (data) {
        self.applySections(data.sections);
        self.views.forEach(function (v) { v.message(''); });
        if (view) view.announce(quantity === 0 ? 'Removed from your cart.' : 'Quantity updated.');
      })
      .catch(function (err) {
        console.error('[cart] change failed:', err);
        if (view) view.message(err.message || 'Something went wrong. Please try again.');
        self.refresh();
      })
      .then(function () { self.setBusy(false); });
  };

  // Re-fetch the sections without touching the cart (header icon, third-party changes).
  Cart.prototype.refresh = function () {
    var self = this;
    return fetch(window.location.pathname + '?sections=' + encodeURIComponent(this.sectionIds()), { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) { self.applySections(sections); })
      .catch(function () {});
  };

  Cart.prototype.applySections = function (sections) {
    if (!sections) return;
    var count = null;
    this.views.forEach(function (v) {
      if (!v.sectionId || !sections[v.sectionId]) return;
      v.apply(sections[v.sectionId]);
      count = v.root.getAttribute('data-cart-item-count');
    });
    if (count != null) {
      this.selfCount = true;
      qa('[data-cart-count]').forEach(function (el) { if (el.textContent !== count) el.textContent = count; });
      var self = this;
      setTimeout(function () { self.selfCount = false; }, 0);
    }
  };

  Cart.prototype.scrollTop = function () {
    var body = this.drawer && q('[data-cart-body]', this.drawer.root);
    if (body) { try { body.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' }); } catch (_) { body.scrollTop = 0; } }
  };

  function lineName(data) {
    var it = data && (data.items ? data.items[0] : data);
    if (!it || !it.product_title) return 'Item';
    return it.product_title + (it.variant_title && it.variant_title !== 'Default Title' ? ', ' + it.variant_title : '');
  }

  /* ---------------------------------------------------------------- boot */
  function init() {
    var root = q('[data-cart-drawer]');
    var cart = new Cart(root);
    window.cartDrawer = cart;
    window.wsCart = cart;

    var pending = window.__cartDrawerPendingForms || [];
    window.__cartDrawerPendingForms = [];
    pending.forEach(function (f) { cart.addFromForm(f); });
    if (window.__cartDrawerWantsOpen && !pending.length) { cart.refresh(); cart.open(); }
    window.__cartDrawerWantsOpen = false;

    // Something else changed the header count (a quick-buy widget, the theme's own cart code):
    // refresh our views and open the drawer on an increase. Our own updates are ignored.
    var headerCount = q('.site-header [data-cart-count], .ws-hdr [data-cart-count]');
    if (headerCount) {
      var last = parseInt(headerCount.textContent, 10) || 0;
      new MutationObserver(function () {
        var now = parseInt(headerCount.textContent, 10) || 0;
        if (now === last) return;
        var up = now > last;
        last = now;
        if (cart.selfCount) return;
        cart.refresh().then(function () { if (up) cart.open(); });
      }).observe(headerCount, { childList: true, characterData: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
